var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebooks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.505h-2.724V15.74c0-.662.444-.817.758-.817h1.922V12.01L21.308 12c-2.94 0-3.608 2.173-3.608 3.563v1.942H16v3.001h1.7V29h3.576v-8.494h2.412L24 17.505z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cGF0aCBkPSJNMjQgMTcuNTA0N0gyMS4yNzU1VjE1Ljc0MDNDMjEuMjc1NSAxNS4wNzc3IDIxLjcyMDIgMTQuOTIzMiAyMi4wMzM1IDE0LjkyMzJDMjIuMzQ2IDE0LjkyMzIgMjMuOTU2MiAxNC45MjMyIDIzLjk1NjIgMTQuOTIzMlYxMi4wMTAyTDIxLjMwODMgMTJDMTguMzY4OSAxMiAxNy42OTk5IDE0LjE3MjYgMTcuNjk5OSAxNS41NjI5VjE3LjUwNDdIMTZWMjAuNTA2M0gxNy42OTk5QzE3LjY5OTkgMjQuMzU4NSAxNy42OTk5IDI5IDE3LjY5OTkgMjlIMjEuMjc1NUMyMS4yNzU1IDI5IDIxLjI3NTUgMjQuMzEyOCAyMS4yNzU1IDIwLjUwNjNIMjMuNjg4MkwyNCAxNy41MDQ3WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgFacebooks as ReactComponent };